import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";

export class DeleteRedovisningshanvisningStyrningCommand extends BasicCommand<DeleteRedovisningshanvisningStyrningCommand> {
    get primaryKey(): IPrimaryKey<DeleteRedovisningshanvisningStyrningCommand> {
        return {
            guid: this.guid
        };
    }
    guid: string;
    static readonly $groupKey = "Redovisningshanvisning";
    static readonly $type = "DeleteRedovisningshanvisningStyrningCommand";
    constructor(init: (instance: DeleteRedovisningshanvisningStyrningCommand) => void) {
        super(DeleteRedovisningshanvisningStyrningCommand.$type, DeleteRedovisningshanvisningStyrningCommand.$groupKey, CommandType.Delete);
        init(this);
    }
}
